var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient } from "@wix/sdk";
import { site } from "@wix/site";
import { ecom } from "@wix/site-ecom";
import { currentCart } from "@wix/ecom";
import { products, catalogVersioning, productsV3 } from "@wix/stores";
import { buildContainer, ensureAddToCartButtonOrCustomizeDisplayed, getAddToCartButton, getBackground, getBuyNowButton, getContainer, getIframe, getMerchantCustomizeButton, getParentAddToCartButton, getStore, getTranslatedAddToCart, getTranslations, hideMerchantCustomizeButton, isLargeVersion, isWixProduct, isWixProductV3, loadCss, removeContainer, removeIframeElement } from "./utils";
function ZakekeWixBoot() {
    const zakekeAppId = window.zakekeAppId || "c429b29c-a6df-404e-aff1-d6835ce2074c";
    const wixClient = createClient({
        auth: site.auth(),
        host: site.host({ applicationId: zakekeAppId }),
        modules: { currentCart, ecom, products, catalogVersioning, productsV3 }
    });
    var zakekeIsSetup = false;
    var zakekeAppInstanceVersionLogged = false;
    function getCatalogVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield wixClient.catalogVersioning.getCatalogVersion();
                console.log("[ZKK] Catalog version: ", response);
                window.zakeke.catalogVersion = response.catalogVersion;
                return window.zakeke.catalogVersion;
            }
            catch (err) {
                console.log('[ZKK] error getting catalog version', err);
                window.zakeke.catalogVersion = catalogVersioning.Version.V1_CATALOG;
                return window.zakeke.catalogVersion;
            }
        });
    }
    function fetchInstanceSite(instanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (window.zakekeWixInstanceSite)
                return;
            const requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };
            const url = `${window.zakekeApis}/api/v1/wix/getwixinstancesite?instanceId=${instanceId}`;
            var response = yield fetch(url, requestOptions);
            if (response.ok) {
                const json = yield response.json();
                const instanceSite = json !== null && json !== void 0 ? json : null;
                window.zakekeWixInstanceSite = instanceSite;
            }
            else {
                throw new Error('getWixInstancesite error');
            }
        });
    }
    function fetchZakekeIntegrationSettings(instanceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };
            const url = `${window.zakekeApis}/api/v1/wix/settings?instanceId=${instanceId}`;
            var response = yield fetch(url, requestOptions);
            if (response.ok) {
                const json = yield response.json();
                const settings = json !== null && json !== void 0 ? json : null;
                window.zakekeIntegrationSettings = settings;
            }
            else {
                throw new Error('getZakekeIntegrationSettings error');
            }
        });
    }
    function addZakeke() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const isWixNewProductPage = ((_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.isWixNewProductPage) || (!document.querySelector('button[data-hook="add-to-cart"]') && !!document.querySelector('button[aria-label^="' + getTranslatedAddToCart() + '" i]'));
            window.zakeke = null;
            const url = new URL(window.location.href);
            window.zakeke = {
                catalogVersion: null,
                isWixNewProductPage: isWixNewProductPage,
                client: "wix",
                userId: null,
                loadingImg: null,
                isZakekeButton: !!document.querySelector('button[id="zakeke-customize-button"]'),
                instanceId: getStore(),
                productId: null,
                visitorId: null,
                locale: (window.wixEmbedsAPI && window.wixEmbedsAPI.getLanguage()) || "en",
                apikey: null,
                product: null,
                designId: null,
                iFrameUrl: null,
                parentAddToCartButtonDiv: getParentAddToCartButton(isWixNewProductPage),
                addTocartButton: getAddToCartButton(isWixNewProductPage),
                customizeButton: null,
                sharedDesignId: url.searchParams.get('shared') || null
            };
        });
    }
    function isZakekeProduct(instanceId, productId, visitorId) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };
            const url = `${window.zakekeApis}/api/v1/wix/checkproduct?productId=${productId}&instanceId=${instanceId}&visitorId=${visitorId}`;
            var response = yield fetch(url, requestOptions);
            if (response.ok) {
                const text = yield response.text();
                if (text === 'true') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        });
    }
    function getProductDetailWixStores(productId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            console.log('[ZKK] Catalog version: ', window.zakeke.catalogVersion);
            if (window.zakeke.catalogVersion === "V1_CATALOG") {
                data = yield wixClient.products.getProduct(productId);
            }
            else if (window.zakeke.catalogVersion === "V3_CATALOG") {
                const response = yield wixClient.productsV3.getProduct(productId, {
                    fields: [productsV3.SingleEntityOpsRequestedFields.VARIANT_OPTION_CHOICE_NAMES]
                });
                data = {
                    product: response
                };
            }
            return data.product;
        });
    }
    function addCustomizeButtonForNewPage() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (window.zakeke.isZakekeButton) {
                return;
            }
            const merchantButton = getMerchantCustomizeButton();
            if (merchantButton) {
                yield customizeButton(merchantButton);
            }
            else {
                let addToCartButton = getAddToCartButton();
                let customizeButton = window.zakeke.customizeButton;
                let parent = addToCartButton.parentNode.parentNode.cloneNode(true);
                let buyNow = getBuyNowButton();
                parent.classList.add("zakeke-customize-div");
                if (buyNow) {
                    buyNow.parentNode.parentNode.parentNode.insertBefore(parent, buyNow.parentNode.parentNode);
                }
                else {
                    window.zakeke.parentAddToCartButtonDiv.parentNode.parentNode.appendChild(parent);
                }
                parent = (_a = document.querySelectorAll(".zakeke-customize-div")) === null || _a === void 0 ? void 0 : _a[0];
                window.zakeke.customizeButton.style.marginRight = '0px';
                if ((_b = window.zakekeIntegrationSettings) === null || _b === void 0 ? void 0 : _b.customizeButtonLabel) {
                    window.zakeke.customizeButton.textContent = window.zakekeIntegrationSettings.customizeButtonLabel;
                }
                else {
                    window.zakeke.customizeButton.textContent = getTranslations() ? getTranslations()['Customize'] : 'Customize';
                }
                const enableCustomizeButton = yield shouldEnableCustomizeButton();
                toogleEnableCustomizeButton(enableCustomizeButton);
                const parentButton = parent.querySelector('button[aria-label^="' + getTranslatedAddToCart() + '" i]').parentNode;
                parentButton.removeChild(parentButton.firstChild);
                parentButton.appendChild(window.zakeke.customizeButton);
            }
        });
    }
    function addCustomizeButton() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (window.zakeke.isZakekeButton) {
                return;
            }
            const merchantButton = getMerchantCustomizeButton();
            if (merchantButton) {
                yield customizeButton(merchantButton);
            }
            else {
                let addToCartButton = getAddToCartButton();
                let parent = getParentAddToCartButton().cloneNode(true);
                let buyNow = getBuyNowButton();
                parent.classList.add("zakeke-customize-div");
                if (buyNow) {
                    buyNow.parentNode.parentNode.insertBefore(parent, buyNow.parentNode);
                }
                else {
                    window.zakeke.parentAddToCartButtonDiv.parentNode.appendChild(parent);
                }
                parent = (_a = document.querySelectorAll(".zakeke-customize-div")) === null || _a === void 0 ? void 0 : _a[0];
                while (parent.firstChild) {
                    parent.removeChild(parent.lastChild);
                }
                window.zakeke.customizeButton.style.marginRight = '0px';
                if ((_b = window.zakekeIntegrationSettings) === null || _b === void 0 ? void 0 : _b.customizeButtonLabel) {
                    window.zakeke.customizeButton.textContent = window.zakekeIntegrationSettings.customizeButtonLabel;
                }
                else {
                    window.zakeke.customizeButton.textContent = getTranslations() ? getTranslations()['Customize'] : 'Customize';
                }
                const enableCustomizeButton = yield shouldEnableCustomizeButton();
                toogleEnableCustomizeButton(enableCustomizeButton);
                parent.appendChild(window.zakeke.customizeButton);
            }
        });
    }
    function addAddToCartButton(removeZakekeButton) {
        var _a, _b;
        if (!((_a = window.zakekeIntegrationSettings) === null || _a === void 0 ? void 0 : _a.forceCustomization) || removeZakekeButton)
            window.zakeke.addTocartButton.disabled = false;
        if (removeZakekeButton) {
            let parent = (_b = document.querySelectorAll(".zakeke-customize-div")) === null || _b === void 0 ? void 0 : _b[0];
            if (parent) {
                while (parent.firstChild) {
                    parent.removeChild(parent.lastChild);
                }
                parent.parentNode.removeChild(parent);
            }
            window.zakeke.parentAddToCartButtonDiv.childNodes.forEach(c => {
                if (c.id === 'zakeke-customize-button') {
                    window.zakeke.parentAddToCartButtonDiv.removeChild(c);
                }
            });
        }
    }
    function getCurrentProductSelection() {
        var _a;
        let selections = null;
        if (!((_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.product))
            return null;
        if (isWixProduct(window.zakeke.product)) {
            selections = getCurrentProductSelectionV1();
        }
        else if (isWixProductV3(window.zakeke.product)) {
            selections = getCurrentProductSelectionV3();
        }
        return selections;
    }
    function getCurrentProductSelectionV1() {
        if (!isWixProduct(window.zakeke.product))
            return;
        let selections = null;
        if (isWixNewIntegration() &&
            window.zakekeViewContentData.options.length > 0 &&
            window.zakekeCustomizeProductData != null &&
            window.zakekeCustomizeProductData.optionsSelectionsIds.length > 0) {
            selections = window.zakekeCustomizeProductData.optionsSelectionsIds.reduce((acc, curr, i) => {
                const optionValue = window.zakekeViewContentData.options.find(o => o.id === curr).value;
                const option = window.zakeke.product.productOptions[i];
                if (!option)
                    return acc;
                const selection = option.choices.find(c => c.value === optionValue);
                const newSelection = Object.assign(Object.assign({}, selection), { id: curr, category: option.name });
                return [...acc, newSelection];
            }, []);
        }
        return selections;
    }
    function getCurrentProductSelectionV3() {
        if (!isWixProductV3(window.zakeke.product))
            return;
        let selections = null;
        if (isWixNewIntegration() &&
            window.zakekeViewContentData.options.length > 0 &&
            window.zakekeCustomizeProductData != null &&
            window.zakekeCustomizeProductData.optionsSelectionsIds.length > 0) {
            selections = window.zakekeCustomizeProductData.optionsSelectionsIds.reduce((acc, curr) => {
                var _a, _b, _c, _d;
                const optionValue = window.zakekeViewContentData.options.find(o => o.id === curr).value;
                const option = ((_a = window.zakeke.product.options) === null || _a === void 0 ? void 0 : _a.find(o => o.choicesSettings.choices.find(c => c.colorCode === optionValue || c.name === optionValue))) || null;
                const modifier = ((_b = window.zakeke.product.modifiers) === null || _b === void 0 ? void 0 : _b.find(o => o.choicesSettings.choices.find(c => c.colorCode === optionValue || c.name === optionValue))) || null;
                if (!option && !modifier)
                    return acc;
                const selection = ((_c = option === null || option === void 0 ? void 0 : option.choicesSettings.choices) === null || _c === void 0 ? void 0 : _c.find(c => c.colorCode === optionValue || c.name === optionValue)) ||
                    ((_d = modifier === null || modifier === void 0 ? void 0 : modifier.choicesSettings.choices) === null || _d === void 0 ? void 0 : _d.find(c => c.colorCode === optionValue || c.name === optionValue)) || null;
                const newSelection = Object.assign(Object.assign({}, selection), { id: curr, category: (option === null || option === void 0 ? void 0 : option.name) || (modifier === null || modifier === void 0 ? void 0 : modifier.name), value: (selection === null || selection === void 0 ? void 0 : selection.colorCode) || (selection === null || selection === void 0 ? void 0 : selection.name) });
                return [...acc, newSelection];
            }, []);
        }
        return selections;
    }
    function addClickToButton(button) {
        button.addEventListener('click', () => {
            var _a, _b;
            if (window.zakeke.designId) {
                removeContainer();
                buildContainer();
                var iframe = getIframe();
                iframe.src = window.zakeke.iFrameUrl + '&designdocid=' + window.zakeke.designId;
                iframe.style.display = 'block';
            }
            else {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                let selections = getCurrentProductSelection();
                var raw = JSON.stringify({
                    "instanceId": window.zakeke.instanceId,
                    "productId": window.zakeke.productId,
                    "visitorId": window.zakeke.visitorId,
                    "userId": window.zakeke.userId,
                    "locale": window.zakeke.locale,
                    "design": null,
                    "selections": selections,
                    "shared": window.zakeke.sharedDesignId,
                    "qty": (_b = (_a = window.zakekeCustomizeProductData) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 1
                });
                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: raw,
                    redirect: 'follow'
                };
                var resp = fetch(window.zakekeApis + "/api/v1/wix/getiframe", requestOptions);
                removeContainer();
                buildContainer();
                resp.then(r => {
                    r.json().then(result => {
                        let iframe = getIframe();
                        let iframeSrc = isLargeVersion() ? result.customizerLargeUrl : result.customizerSmallUrl;
                        iframeSrc = `${iframeSrc}&zakekeWixNewIntegration=${isWixNewIntegration() ? 1 : 0}`;
                        iframe.style.display = 'block';
                        iframe.src = iframeSrc;
                        window.zakeke.iFrameUrl = iframeSrc;
                    }).catch(error => console.error('[ZKK] error', error));
                }).catch(error => console.error('[ZKK] error', error));
            }
        });
    }
    function calculatePriceConditionPercentage(condition, productPrice) {
        if (condition.priceType === 1) {
            return productPrice * (condition.priceToAdd / 100) * condition.multiplier;
        }
        return 0;
    }
    function calculateZakekePrice(price, zakekePercentPrice, zakekePrice, conditions, qty) {
        let finalPrice = zakekePrice;
        if (zakekePercentPrice) {
            finalPrice += price * (zakekePercentPrice / 100);
        }
        if (conditions) {
            finalPrice += conditions.reduce((acc, c) => acc + calculatePriceConditionPercentage(c, price * qty), 0);
        }
        return finalPrice;
    }
    function getChoicesByOptionsIds(optionsIds) {
        if (optionsIds == null || optionsIds.length == 0)
            return null;
        if (isWixProduct(window.zakeke.product)) {
            return getChoicesByOptionsIdsV1(optionsIds);
        }
        else if (isWixProductV3(window.zakeke.product)) {
            return getChoicesByOptionsIdsV3(optionsIds);
        }
    }
    function getChoicesByOptionsIdsV1(optionsIds) {
        if (!isWixProduct(window.zakeke.product))
            return;
        const choices = optionsIds.reduce((acc, curr) => {
            const option = window.zakekeViewContentData.options.find(o => o.id === curr);
            const productOption = window.zakeke.product.productOptions.find(o => o.choices.find(c => c.value === option.value));
            const choice = productOption.choices.find(c => c.value === option.value);
            const optionKey = productOption.name;
            const optionValue = choice.description;
            acc[optionKey] = optionValue;
            return acc;
        }, {});
        return choices;
    }
    function getChoicesByOptionsIdsV3(optionsIds) {
        if (!isWixProductV3(window.zakeke.product))
            return;
        const choices = optionsIds.reduce((acc, curr) => {
            var _a, _b;
            const option = window.zakekeViewContentData.options.find(o => o.id === curr);
            const productOption = ((_a = window.zakeke.product.options) === null || _a === void 0 ? void 0 : _a.find(o => o.choicesSettings.choices.find(c => c.colorCode === option.value || c.name === option.value))) || null;
            const modifier = ((_b = window.zakeke.product.modifiers) === null || _b === void 0 ? void 0 : _b.find(o => o.choicesSettings.choices.find(c => c.colorCode === option.value || c.name === option.value))) || null;
            const choice = (productOption === null || productOption === void 0 ? void 0 : productOption.choicesSettings.choices.find(c => c.colorCode === option.value || c.name === option.value)) ||
                (modifier === null || modifier === void 0 ? void 0 : modifier.choicesSettings.choices.find(c => c.colorCode === option.value || c.name === option.value));
            const optionKey = (productOption === null || productOption === void 0 ? void 0 : productOption.name) || (modifier === null || modifier === void 0 ? void 0 : modifier.name);
            const optionValue = choice === null || choice === void 0 ? void 0 : choice.name;
            acc[optionKey] = optionValue;
            return acc;
        }, {});
        return choices;
    }
    function getOptionsIdsByChoices(choices) {
        if (choices == null)
            return null;
        if (isWixProduct(window.zakeke.product)) {
            return getOptionsIdsByChoicesV1(choices);
        }
        else if (isWixProductV3(window.zakeke.product)) {
            return getOptionsIdsByChoicesV3(choices);
        }
    }
    function getOptionsIdsByChoicesV1(choices) {
        if (!isWixProduct(window.zakeke.product))
            return;
        let optionsIds = [];
        Object.entries(choices).forEach(([key, value]) => {
            var _a;
            let option = window.zakeke.product.productOptions.find(o => o.name === key);
            if (!option)
                return;
            let optionChoice = option.choices.find(c => c.description === value);
            if (!optionChoice)
                return;
            let optionValue = (_a = window.zakekeViewContentData.options.find(o => o.value === optionChoice.value)) === null || _a === void 0 ? void 0 : _a.id;
            optionsIds.push(optionValue);
        });
        return optionsIds;
    }
    function getOptionsIdsByChoicesV3(choices) {
        if (!isWixProductV3(window.zakeke.product))
            return;
        let optionsIds = [];
        Object.entries(choices).forEach(([key, value]) => {
            var _a, _b, _c;
            const option = ((_a = window.zakeke.product.options) === null || _a === void 0 ? void 0 : _a.find(o => o.name === key)) || null;
            const modifier = ((_b = window.zakeke.product.modifiers) === null || _b === void 0 ? void 0 : _b.find(o => o.name === key)) || null;
            if (!option && !modifier)
                return;
            let optionChoice = (option === null || option === void 0 ? void 0 : option.choicesSettings.choices.find(c => c.colorCode === value || c.name === value)) ||
                (modifier === null || modifier === void 0 ? void 0 : modifier.choicesSettings.choices.find(c => c.colorCode === value || c.name === value));
            if (!optionChoice)
                return;
            let optionValue = (_c = window.zakekeViewContentData.options.find(o => o.value === optionChoice.colorCode || o.value === optionChoice.name)) === null || _c === void 0 ? void 0 : _c.id;
            optionsIds.push(optionValue);
        });
        return optionsIds;
    }
    function getVariantFromZakekeProductByOptionsIds(optionsIds) {
        if (optionsIds == null || optionsIds.length == 0)
            return null;
        const choices = getChoicesByOptionsIds(optionsIds);
        if (isWixProduct(window.zakeke.product)) {
            return getVariantFromZakekeProductByOptionsIdsV1(choices);
        }
        else if (isWixProductV3(window.zakeke.product)) {
            return getVariantFromZakekeProductByOptionsIdsV3(choices);
        }
    }
    function getVariantFromZakekeProductByOptionsIdsV1(choices) {
        if (!isWixProduct(window.zakeke.product))
            return null;
        const variant = window.zakeke.product.variants.find(v => Object.entries(v.choices).every(([key, value]) => choices[key] === value));
        return variant;
    }
    function getVariantFromZakekeProductByOptionsIdsV3(choices) {
        var _a, _b;
        if (!isWixProductV3(window.zakeke.product))
            return null;
        const variant = (_b = (_a = window.zakeke.product.variantsInfo) === null || _a === void 0 ? void 0 : _a.variants) === null || _b === void 0 ? void 0 : _b.find(v => v.choices.every(c => choices[c.optionChoiceNames.optionName] === c.optionChoiceNames.choiceName));
        return variant;
    }
    function getChoicesByAttributes(attributes) {
        const choices = attributes.reduce((acc, curr) => {
            const choice = { [curr.Id]: curr.Value.Label };
            return Object.assign(Object.assign({}, acc), choice);
        }, {});
        return choices;
    }
    function getProductInventoryForCurrentSelection(optionsIds, quantity) {
        if (isWixProduct(window.zakeke.product)) {
            return getProductInventoryForCurrentSelectionV1(optionsIds, quantity);
        }
        else if (isWixProductV3(window.zakeke.product)) {
            return getProductInventoryForCurrentSelectionV3(optionsIds, quantity);
        }
    }
    function getProductInventoryForCurrentSelectionV1(optionsIds, quantity) {
        if (!isWixProduct(window.zakeke.product))
            return;
        if (optionsIds == null || optionsIds.length == 0 || !window.zakeke.product.manageVariants) {
            return {
                isOutOfStock: window.zakeke.product.stock.inventoryStatus === 'OUT_OF_STOCK',
                quantity: quantity,
                price: window.zakeke.product.priceData.discountedPrice,
                finalPrice: window.zakeke.product.priceData.discountedPrice * quantity
            };
        }
        let v = getVariantFromZakekeProductByOptionsIds(optionsIds);
        if (v && v.stock.inStock && (!v.stock.trackQuantity || quantity <= v.stock.quantity)) {
            return {
                isOutOfStock: false,
                quantity: quantity,
                price: v.variant.priceData.discountedPrice,
                finalPrice: v.variant.priceData.discountedPrice * quantity
            };
        }
        return { isOutOfStock: true };
    }
    function getProductInventoryForCurrentSelectionV3(optionsIds, quantity) {
        var _a;
        if (!isWixProductV3(window.zakeke.product))
            return;
        if (optionsIds == null || optionsIds.length == 0 || !(window.zakeke.product.options.length > 0)) {
            const variant = (_a = window.zakeke.product.variantsInfo) === null || _a === void 0 ? void 0 : _a.variants[0];
            return {
                isOutOfStock: !variant.inventoryStatus.inStock,
                quantity: quantity,
                price: variant.price.actualPrice.amount,
                finalPrice: Number.parseFloat(variant.price.actualPrice.amount) * quantity
            };
        }
        let v = getVariantFromZakekeProductByOptionsIds(optionsIds);
        if (v && v.inventoryStatus.inStock) {
            return {
                isOutOfStock: false,
                quantity: quantity,
                price: Number.parseFloat(v.price.actualPrice.amount),
                finalPrice: Number.parseFloat(v.price.actualPrice.amount) * quantity
            };
        }
        return { isOutOfStock: true };
    }
    function shouldEnableCustomizeButton() {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            if (!isWixNewIntegration())
                return true;
            if (!ensureMandatoryCustomTextFieldsValued()) {
                console.log('[ZKK] Widget installed on new integration but product has custom text field required not valued');
                return false;
            }
            if (!window.zakekeViewContentData || window.zakekeViewContentData.options.length === 0) {
                if (!((_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.product))
                    return true;
                const product = window.zakeke.product;
                if (isWixProduct(product)) {
                    const stock = product.stock;
                    if (stock.inventoryStatus === 'IN_STOCK')
                        return true;
                    else
                        return false;
                }
                else if (isWixProductV3(product)) {
                    const stock = (_b = product.variantsInfo) === null || _b === void 0 ? void 0 : _b.variants[0].inventoryStatus;
                    if (stock.inStock)
                        return true;
                    else
                        return false;
                }
            }
            if (window.zakekeViewContentData.options.length === 1 && window.zakekeCustomizeProductData == null) {
                const optionID = window.zakekeViewContentData.options[0].id;
                window.zakekeCustomizeProductData = {
                    optionsSelectionsIds: [optionID],
                    quantity: 1,
                };
            }
            if (window.zakekeCustomizeProductData != null &&
                window.zakekeCustomizeProductData.optionsSelectionsIds.length > 0 &&
                ((_c = window.zakeke) === null || _c === void 0 ? void 0 : _c.product) != null) {
                const productInventory = getProductInventoryForCurrentSelection(window.zakekeCustomizeProductData.optionsSelectionsIds, (_e = (_d = window.zakekeCustomizeProductData) === null || _d === void 0 ? void 0 : _d.quantity) !== null && _e !== void 0 ? _e : 1);
                if (productInventory && !productInventory.isOutOfStock)
                    return true;
            }
            return false;
        });
    }
    function toogleEnableCustomizeButton(enable) {
        const customizeButton = (getMerchantCustomizeButton() || window.zakeke.customizeButton);
        customizeButton.disabled = !enable;
        customizeButton.style.opacity = !enable ? '0.7' : '1';
    }
    function customizeButton(buttonInput, isWixNewProductPage) {
        var _a;
        if (isWixNewProductPage === void 0) { isWixNewProductPage = (_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.isWixNewProductPage; }
        return __awaiter(this, void 0, void 0, function* () {
            const enableCustomizeButton = yield shouldEnableCustomizeButton();
            if (buttonInput) {
                buttonInput.style.opacity = !enableCustomizeButton ? 0.7 : 1;
                buttonInput.disabled = !enableCustomizeButton;
                buttonInput.style.display = 'block';
                addClickToButton(buttonInput);
                return buttonInput;
            }
            const button = getAddToCartButton(isWixNewProductPage);
            const clone = isWixNewProductPage ? button.parentNode.parentNode.cloneNode(true) : button.cloneNode(true);
            const clonedButtonTag = isWixNewProductPage ? clone.querySelector('button[aria-label^="' + getTranslatedAddToCart() + '" i]') : clone;
            if (isWixNewProductPage) {
                clonedButtonTag.children[0].children[0].textContent = getTranslations() ? getTranslations()['Customize'] : 'Customize';
            }
            else {
                clonedButtonTag.children[0].textContent = getTranslations() ? getTranslations()['Customize'] : 'Customize';
                clonedButtonTag.style.marginTop = '1rem';
            }
            clonedButtonTag.id = 'zakeke-customize-button';
            clonedButtonTag.style.opacity = !enableCustomizeButton ? '0.7' : '1';
            clonedButtonTag.style.display = 'block';
            clonedButtonTag.disabled = !enableCustomizeButton;
            addClickToButton(clonedButtonTag);
            return clonedButtonTag;
        });
    }
    function fetchUser() {
        return __awaiter(this, void 0, void 0, function* () {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                body: null,
                redirect: 'follow'
            };
            var siteDomain = window.location.host;
            var resp = yield fetch(`https://${siteDomain}/_api/apps/current-member/${zakekeAppId}`, requestOptions);
            const result = yield resp.json();
            if (result && result.member && result.member.id) {
                if (window.zakeke) {
                    window.zakeke.userId = result.member.id;
                }
            }
        });
    }
    function addToCart(data) {
        var _a, _b, _c, _d;
        const color = data.colorId;
        const attributes = JSON.parse(color);
        let choices = getChoicesByAttributes(attributes);
        const choicesKeys = Object.keys(choices);
        let selections = getCurrentProductSelection();
        let choicesDiff = selections === null || selections === void 0 ? void 0 : selections.filter(s => !choicesKeys.includes(s.category)).map(s => ({ [s.category]: s.description || s.name }));
        choicesDiff === null || choicesDiff === void 0 ? void 0 : choicesDiff.forEach((c) => choices = Object.assign(Object.assign({}, choices), c));
        const productId = window.zakekeViewContentData.id;
        const quantity = (_b = (_a = window.zakekeCustomizeProductData) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 1;
        let productCustomTextFields = [];
        if (isWixProduct(window.zakeke.product)) {
            productCustomTextFields = window.zakeke.product.customTextFields ?
                window.zakeke.product.customTextFields.map((t, i) => { var _a, _b, _c; return ({ title: t.title, value: (_c = (_b = (_a = window.zakekeCustomizeProductData) === null || _a === void 0 ? void 0 : _a.customTextFields) === null || _b === void 0 ? void 0 : _b[i]) !== null && _c !== void 0 ? _c : ' ' }); })
                : [];
        }
        else if (isWixProductV3(window.zakeke.product)) {
            productCustomTextFields = window.zakeke.product.modifiers ?
                window.zakeke.product.modifiers
                    .filter(m => m.freeTextSettings != null)
                    .map((m, i) => { var _a, _b, _c; return ({ title: m.freeTextSettings.title, value: (_c = (_b = (_a = window.zakekeCustomizeProductData) === null || _a === void 0 ? void 0 : _a.customTextFields) === null || _b === void 0 ? void 0 : _b[i]) !== null && _c !== void 0 ? _c : ' ' }); })
                : [];
        }
        productCustomTextFields = productCustomTextFields.map(t => ({
            title: t.title,
            value: t.title.toLowerCase().includes('customization token') ? ' ' : t.value
        }));
        const customTextFields = [
            {
                title: "Customization token",
                value: window.zakeke.designId
            },
            ...productCustomTextFields
        ];
        const itemOptions = {
            customTextFields: customTextFields.reduce((acc, curr) => {
                acc[curr.title] = curr.value;
                return acc;
            }, {})
        };
        if ((isWixProduct(window.zakeke.product) && window.zakeke.product.manageVariants) || (isWixProductV3(window.zakeke.product) && ((_c = window.zakeke.product.options) === null || _c === void 0 ? void 0 : _c.length) > 0)) {
            const variant = getVariantFromZakekeProductByOptionsIds(getOptionsIdsByChoices(choices));
            itemOptions.variantId = variant._id;
        }
        else {
            itemOptions.options = choices;
        }
        const catalogOverrideFields = ((_d = data.previews) === null || _d === void 0 ? void 0 : _d.length) > 0 ? { image: data.previews[0].url } : {};
        console.log('[ZKK] AddToCart: catalogOverrideFields', { catalogOverrideFields });
        const addToCartOptions = {
            lineItems: [
                {
                    quantity,
                    catalogReference: {
                        appId: "215238eb-22a5-4c36-9e7b-e7c08025e04e",
                        catalogItemId: productId,
                        options: itemOptions
                    },
                }
            ]
        };
        console.log('[ZKK] AddToCart: addToCartOptions', { addToCartOptions });
        wixClient.currentCart.addToCurrentCart(addToCartOptions)
            .then((response) => __awaiter(this, void 0, void 0, function* () {
            console.log('[ZKK] AddToCart: response', response);
            yield wixClient.ecom.refreshCart();
            yield wixClient.ecom.navigateToCartPage()
                .catch(err => {
                console.error('[ZKK] AddToCart: navigateToCartPage error', err);
                if (getContainer() && getBackground() && getIframe())
                    setTimeout(() => removeIframeElement(), 2000);
            });
        }))
            .catch(error => {
            console.error('[ZKK] AddToCart: error', error);
        });
    }
    function designChange(data) {
        var _a, _b, _c, _d;
        const color = data.design.color;
        const attributes = JSON.parse(color);
        const choices = getChoicesByAttributes(attributes);
        const optionsIds = getOptionsIdsByChoices(choices);
        const choicesKeys = Object.keys(choices);
        let selections = getCurrentProductSelection();
        let choicesDiff = selections === null || selections === void 0 ? void 0 : selections.filter(s => !choicesKeys.includes(s.category));
        let optionsDiff = (choicesDiff === null || choicesDiff === void 0 ? void 0 : choicesDiff.length) > 0 ? choicesDiff.map(s => s.id) : [];
        optionsIds.push(...optionsDiff);
        const productInventory = getProductInventoryForCurrentSelection(optionsIds, (_b = (_a = window.zakekeCustomizeProductData) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 1);
        let zakekePrice = !productInventory.isOutOfStock ?
            calculateZakekePrice(productInventory.price, data.design.percentPrice || 0, data.design.price || 0, data.design.conditions || [], (_d = (_c = window.zakekeCustomizeProductData) === null || _c === void 0 ? void 0 : _c.quantity) !== null && _d !== void 0 ? _d : 1)
            : 0;
        getIframe().contentWindow.postMessage({
            data: Object.assign(Object.assign({}, data), { isOutOfStock: productInventory.isOutOfStock, finalPrice: productInventory.finalPrice + zakekePrice }),
            zakekeMessageType: 1
        }, '*');
    }
    function productAttributes(data) {
        var _a;
        if (!((_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.product)) {
            getIframe().contentWindow.postMessage({
                data: {
                    promiseId: data.promiseId,
                    attributes: [],
                    variants: []
                },
                zakekeMessageType: 2
            }, '*');
            return;
        }
        let attributesData = [];
        let variantsData = [];
        if (isWixProduct(window.zakeke.product)) {
            const result = getProductAttributesV1();
            attributesData = result.attributes;
            variantsData = result.variants;
        }
        else if (isWixProductV3(window.zakeke.product)) {
            const result = getProductAttributesV3();
            attributesData = result.attributes;
            variantsData = result.variants;
        }
        console.log('[ZKK] productAttributes: ', { attributesData, variantsData });
        getIframe().contentWindow.postMessage({
            data: Object.assign({}, data, {
                attributes: attributesData,
                variants: variantsData
            }),
            zakekeMessageType: 2
        }, '*');
    }
    function getProductAttributesV1() {
        const product = window.zakeke.product;
        if (!product.manageVariants || !product.productOptions || product.productOptions.length === 0) {
            return { attributes: [], variants: [] };
        }
        const attributes = product.productOptions.map((option, index) => ({
            id: option.name,
            label: option.name,
            values: option.choices.map(choice => ({
                id: choice.value,
                label: choice.description
            }))
        }));
        const variants = product.variants.map(variant => {
            return Object.entries(variant.choices).map(([optionName, choiceName]) => {
                var _a, _b;
                const choiceValue = (_b = (_a = product.productOptions
                    .find(o => o.name === optionName)) === null || _a === void 0 ? void 0 : _a.choices.find(c => c.description === choiceName)) === null || _b === void 0 ? void 0 : _b.value;
                return {
                    Id: optionName,
                    Value: {
                        Id: choiceValue
                    }
                };
            });
        });
        return { attributes, variants };
    }
    function getProductAttributesV3() {
        var _a, _b;
        const product = window.zakeke.product;
        if (!product.options || product.options.length === 0) {
            return { attributes: [], variants: [] };
        }
        const attributes = product.options.map((option, index) => ({
            id: option.name,
            label: option.name,
            values: option.choicesSettings.choices.map(choice => ({
                id: choice.colorCode || choice.name,
                label: choice.name
            }))
        }));
        const variants = ((_b = (_a = product.variantsInfo) === null || _a === void 0 ? void 0 : _a.variants) === null || _b === void 0 ? void 0 : _b.map(variant => {
            return variant.choices.map(choice => {
                const option = product.options.find(o => o.name === choice.optionChoiceNames.optionName);
                const choiceItem = option === null || option === void 0 ? void 0 : option.choicesSettings.choices.find(c => c.name === choice.optionChoiceNames.choiceName);
                return {
                    Id: (option === null || option === void 0 ? void 0 : option.name) || choice.optionChoiceNames.optionName,
                    Value: {
                        Id: (choiceItem === null || choiceItem === void 0 ? void 0 : choiceItem.colorCode) || (choiceItem === null || choiceItem === void 0 ? void 0 : choiceItem.name) || choice.optionChoiceNames.choiceName
                    }
                };
            });
        })) || [];
        return { attributes, variants };
    }
    function productPrice(data) {
        const attributes = data.attributes;
        const choices = getChoicesByAttributes(attributes);
        const optionsIds = getOptionsIdsByChoices(choices);
        const choicesKeys = Object.keys(choices);
        let selections = getCurrentProductSelection();
        let choicesDiff = selections === null || selections === void 0 ? void 0 : selections.filter(s => !choicesKeys.includes(s.category));
        let optionsDiff = (choicesDiff === null || choicesDiff === void 0 ? void 0 : choicesDiff.length) > 0 ? choicesDiff.map(s => s.id) : [];
        optionsIds.push(...optionsDiff);
        const productInventory = getProductInventoryForCurrentSelection(optionsIds, data.quantity);
        const zakekePrice = !productInventory.isOutOfStock ?
            calculateZakekePrice(productInventory.price, data.percentPrice, Number.isNaN(data.price) ? 0 : data.price, data.conditions, data.quantity)
            : 0;
        getIframe().contentWindow.postMessage({
            data: {
                promiseId: data.promiseId,
                isOutOfStock: productInventory.isOutOfStock,
                finalPrice: productInventory.finalPrice + zakekePrice
            },
            zakekeMessageType: 3
        }, '*');
    }
    function addToCartMultiple(data) {
    }
    function shareDesign(data) {
        const url = new URL(window.location.href);
        url.searchParams.delete('design');
        url.searchParams.set('shared', data.designDocID);
        getIframe().contentWindow.postMessage({
            zakekeMessageType: 5,
            data: {
                promiseId: data.promiseId,
                url: url.toString()
            }
        }, '*');
    }
    function addToCartNameAndNumber(data) {
    }
    function AddToCartBulkAsNN(data) {
    }
    function zakekeAfterPageLoaded(data) {
        return __awaiter(this, void 0, void 0, function* () {
            zakekeIsSetup = true;
            if (!window.zakeke || (window.zakeke && window.zakeke.productId !== data.productId)) {
                yield ensureAddToCartButtonOrCustomizeDisplayed();
                yield addZakeke();
                yield loading(true);
                const [isZakeke] = yield Promise.all([
                    isZakekeProduct(getStore(), data.productId, data.visitorId),
                    fetchInstanceSite(getStore()),
                    fetchUser()
                ]);
                window.zakeke.customizeButton = yield customizeButton(getMerchantCustomizeButton() || null, window.zakeke.isWixNewProductPage);
                try {
                    if (isZakeke) {
                        yield getCatalogVersion();
                        const product = yield getProductDetailWixStores(data.productId);
                        fillZakekeParams(data, product);
                        yield loading(false, true);
                        zakekeIsSetup = false;
                    }
                    else {
                        yield loading(false, false);
                        zakekeIsSetup = false;
                    }
                }
                catch (err) {
                    console.error('[ZKK] isZakekeProduct', err);
                    yield loading(false, false);
                    zakekeIsSetup = false;
                }
            }
        });
    }
    function loading(load, addZakekeButton) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (load) {
                window.zakeke.addTocartButton.disabled = true;
                if ((_a = window.zakekeIntegrationSettings) === null || _a === void 0 ? void 0 : _a.forceCustomization) {
                    window.zakeke.addTocartButton.style.display = 'none';
                }
            }
            else {
                if (addZakekeButton) {
                    if ((_b = window.zakekeIntegrationSettings) === null || _b === void 0 ? void 0 : _b.forceCustomization) {
                        window.zakeke.addTocartButton.style.display = 'none';
                    }
                    if (window.zakeke.isWixNewProductPage)
                        yield addCustomizeButtonForNewPage();
                    else
                        yield addCustomizeButton();
                    addAddToCartButton(false);
                }
                else {
                    hideMerchantCustomizeButton();
                    addAddToCartButton(true);
                }
            }
        });
    }
    function fillZakekeParams(e, product) {
        const zakeke = window.zakeke;
        zakeke.productId = e.productId;
        zakeke.visitorId = e.visitorId;
        zakeke.product = product;
    }
    function registerListener() {
        window.wixDevelopersAnalytics.register('bbc9fc6f-215e-4860-b7cb-fb51834e4900', function report(eventName, data) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                switch (eventName) {
                    case 'pageview':
                        break;
                    case 'addToCart':
                        window.zakeke = null;
                        break;
                    case 'productPageLoaded':
                        window.zakeke = null;
                        window.zakekeCustomizeProductData = null;
                        console.log("[ZKK] productPageLoaded", data);
                        let parent = (_a = document.querySelectorAll(".zakeke-customize-div")) === null || _a === void 0 ? void 0 : _a[0];
                        if (parent) {
                            while (parent.firstChild) {
                                parent.removeChild(parent.lastChild);
                            }
                            parent.parentNode.removeChild(parent);
                        }
                        if (!zakekeIsSetup) {
                            yield zakekeAfterPageLoaded(data);
                        }
                    case 'purchase':
                        break;
                    case 'ClickProduct':
                        break;
                    case 'CustomEvent':
                        if (data.eventAction === 'Log in Success') {
                            fetchUser();
                        }
                        break;
                    case 'ViewContent':
                        window.zakekeViewContentData = data;
                        break;
                    case 'CustomizeProduct':
                        window.zakekeCustomizeProductData = data;
                        const enableCustomizeButton = yield shouldEnableCustomizeButton();
                        toogleEnableCustomizeButton(enableCustomizeButton);
                        break;
                    default:
                        break;
                }
            });
        });
        if (!window.isZakekeEventListenerSetup) {
            window.addEventListener('message', event => {
                if (event.data.zakekeMessageType === 0) {
                    window.zakeke.designId = event.data.designId;
                    if (!isWixNewIntegration()) {
                        removeIframeElement();
                        return;
                    }
                    addToCart(event.data);
                }
                else if (event.data.zakekeMessageType === 1) {
                    if (!isWixNewIntegration()) {
                        getIframe().contentWindow.postMessage({
                            data: event.data,
                            zakekeMessageType: event.data.zakekeMessageType
                        }, '*');
                        return;
                    }
                    designChange(event.data);
                }
                else if (event.data.zakekeMessageType === 2) {
                    if (!isWixNewIntegration()) {
                        getIframe().contentWindow.postMessage({
                            data: {
                                promiseId: event.data.data.promiseId,
                            },
                            zakekeMessageType: event.data.zakekeMessageType
                        }, '*');
                        return;
                    }
                    productAttributes(event.data.data);
                }
                else if (event.data.zakekeMessageType === 3) {
                    if (!isWixNewIntegration()) {
                        getIframe().contentWindow.postMessage({
                            data: {
                                promiseId: event.data.data.promiseId,
                                isOutOfStock: false,
                                finalPrice: 0
                            },
                            zakekeMessageType: event.data.zakekeMessageType
                        }, '*');
                        return;
                    }
                    productPrice(event.data.data);
                }
                else if (event.data.zakekeMessageType === 4) {
                    if (!isWixNewIntegration()) {
                        return;
                    }
                    console.log("[ZKK] event.data", event.data);
                    addToCartMultiple(event.data.data);
                }
                else if (event.data.zakekeMessageType === 5) {
                    if (!isWixNewIntegration()) {
                        return;
                    }
                    console.log("[ZKK] event.data", event.data);
                    shareDesign(event.data.data);
                }
                else if (event.data.zakekeMessageType === 6) {
                    if (!isWixNewIntegration()) {
                        return;
                    }
                    console.log("[ZKK] event.data", event.data);
                    addToCartNameAndNumber(event.data.data);
                }
                else if (event.data.zakekeMessageType === 8) {
                    if (!isWixNewIntegration()) {
                        return;
                    }
                    console.log("[ZKK] event.data", event.data);
                    AddToCartBulkAsNN(event.data.data);
                }
            });
            window.isZakekeEventListenerSetup = true;
            const observeUrlChange = () => {
                let oldHref = document.location.href;
                const body = document.querySelector("body");
                const observer = new MutationObserver(_ => {
                    if (oldHref !== document.location.href) {
                        oldHref = document.location.href;
                        if (getContainer() && getBackground() && getIframe())
                            setTimeout(() => removeIframeElement(), 2000);
                    }
                });
                observer.observe(body, { childList: true, subtree: true });
            };
            observeUrlChange();
        }
    }
    function ensureMandatoryCustomTextFieldsValued() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let result = false;
        if (!((_a = window.zakeke) === null || _a === void 0 ? void 0 : _a.product))
            return true;
        if (isWixProduct(window.zakeke.product)) {
            const customTextFields = (_d = (_c = (_b = window.zakeke) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.customTextFields) !== null && _d !== void 0 ? _d : [];
            if (!customTextFields || customTextFields.length == 0)
                return true;
            result = !customTextFields.some((c, i) => {
                var _a, _b, _c, _d;
                return c.mandatory === true &&
                    (window.zakekeCustomizeProductData == null ||
                        ((_b = (_a = window.zakekeCustomizeProductData) === null || _a === void 0 ? void 0 : _a.customTextFields) === null || _b === void 0 ? void 0 : _b[i]) == null ||
                        ((_d = (_c = window.zakekeCustomizeProductData) === null || _c === void 0 ? void 0 : _c.customTextFields) === null || _d === void 0 ? void 0 : _d[i]) == '');
            });
        }
        else if (isWixProductV3(window.zakeke.product)) {
            const customTextFields = (_h = (_g = (_f = (_e = window.zakeke) === null || _e === void 0 ? void 0 : _e.product) === null || _f === void 0 ? void 0 : _f.modifiers) === null || _g === void 0 ? void 0 : _g.filter(m => m.freeTextSettings != null)) !== null && _h !== void 0 ? _h : [];
            if (!customTextFields || customTextFields.length == 0)
                return true;
            result = !customTextFields.some((c, i) => {
                var _a, _b, _c, _d;
                return c.mandatory === true &&
                    (window.zakekeCustomizeProductData == null ||
                        ((_b = (_a = window.zakekeCustomizeProductData) === null || _a === void 0 ? void 0 : _a.customTextFields) === null || _b === void 0 ? void 0 : _b[i]) == null ||
                        ((_d = (_c = window.zakekeCustomizeProductData) === null || _c === void 0 ? void 0 : _c.customTextFields) === null || _d === void 0 ? void 0 : _d[i]) == '');
            });
        }
        return result;
    }
    function isWixNewIntegration() {
        var _a, _b;
        const instance = (_b = (_a = window.zakekeWixInstanceSite) === null || _a === void 0 ? void 0 : _a.instance) !== null && _b !== void 0 ? _b : null;
        if (!instance)
            return false;
        if (instance.appName === 'Zakeke - Product Customizer') {
            if (!zakekeAppInstanceVersionLogged) {
                console.log('[ZKK] Product Customizer version: ', instance.appVersion);
                zakekeAppInstanceVersionLogged = true;
            }
            if (instance.appVersion === 'latest')
                return true;
            const majorVersion = parseInt(instance.appVersion.split('.')[0].replace('^', ''));
            if (majorVersion < 3)
                return false;
        }
        return true;
    }
    (function () {
        console.log('[ZKK] zakeke script');
        window.zakekeInstance = window.zakekeInstance || 'https://admin.zakeke.com';
        window.zakekeApis = window.zakekeApis || 'https://api.zakeke.com';
        window.zakekeWixNewIntegration = window.zakekeWixNewIntegration || false;
        loadCss(window.zakekeInstance);
        fetchZakekeIntegrationSettings(getStore());
        window.wixDevelopersAnalytics ? registerListener() : window.addEventListener('wixDevelopersAnalyticsReady', registerListener);
    })();
}
(function ZakekeWixInit() {
    console.log('[ZKK] ZakekeWixInit');
    ZakekeWixBoot();
})();
